import { isWideRoute } from './navItems.js';
import { pathMatches } from './navVisibility.js';

/* THE ADMIN'S HOME KEEPS THE FOOTER (owner, 2026-10-29: "this is our home page
   for admin"). The Overview control room is wide; its board keeps its fixed
   height and the footer follows it, reached by scrolling. Dispatch and the
   calendar still own the whole column. */
const FOOTED_WIDE_ROUTES: readonly string[] = ['/operations'];

/** Does this page render the app footer? Every ordinary route, plus the Overview. */
export function showsFooter(pathname: string): boolean {
  return !isWideRoute(pathname) || FOOTED_WIDE_ROUTES.some((to) => pathMatches(to, pathname));
}
